import { ElementType } from "react";
import { SxProps, TypographyProps } from "@mui/material";

import { StyledTitle } from "./Title.styles";

export interface ITitleProps extends TypographyProps {
  component?: ElementType;
  title?: string;
  noMaxWidth?: boolean;
  sx?: SxProps;
}

export const Title: React.FC<ITitleProps> = ({ component, children, title, noMaxWidth = false, sx }) => {
  return (
    <StyledTitle sx={sx} variant="h5" component={component || "h1"} title={title} noMaxWidth={noMaxWidth}>
      {children}
    </StyledTitle>
  );
};
